<template>
    <div>
        <div class="col-12 row g-0">
            <div class="form-group col-6">
                <label for="equipment-name"> Equipment Name </label>
                <TypeaheadInput
                    placeholder="Start Typing"
                    :getData="getDmesList"
                    :value="dmeData"
                    v-on:valueChanged="changeDmeData"
                />
            </div>
            <div class="text-end col-6" v-if="dmeIndex != 0">
                <i class="fa fa-times fa-2x text-danger p-3" @click="removeEquipment(dmeIndex)"></i>
            </div>
        </div>
        <div class="col-12 row g-0 border-bottom">
            <div class="form-group col-12 col-lg-4 pe-2">
                <label for="provider-name"> Provider Name </label>
                <input type="text" class="form-control" v-model="dmeNeeded.provider" />
            </div>
            <div class="form-group col-12 col-lg-4 px-lg-2">
                <label for="model-no"> Model No. </label>
                <input type="text" class="form-control" v-model="dmeNeeded.modelNo" />
            </div>
            <div class="form-group col-12 col-lg-4 px-lg-2">
                <label for="serial-no"> Serial No. </label>
                <input type="text" class="form-control" v-model="dmeNeeded.serialNo" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./CreateDmeNeededRow.ts"></script>
